/* eslint-disable no-shadow */
import { http } from "@/api/index";
import FetchStatus from "@/constants/fetch-status/FetchStatus";

import {
	GET_EVENT_SETTINGS,
	GET_EVENT_SETTINGS_SUCCESS,
	GET_EVENT_SETTINGS_ERROR,
} from "@/stores/actions/EventsSettings";

import { GET_EVENTS_RECORDS } from "@/stores/actions/EventsRecords.js";

const state = {
	status: FetchStatus.Init,
	data:   [],
	error:  {},
};

const actions = {
	[GET_EVENT_SETTINGS]: ({ commit, dispatch }, monitoringElementId) =>
	{
		commit(GET_EVENT_SETTINGS);

		http.get(`/EventsSettings/${monitoringElementId}`)
			.then((resp) =>
			{
				dispatch(GET_EVENTS_RECORDS, resp.data);
				commit(GET_EVENT_SETTINGS_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_EVENT_SETTINGS_ERROR, error.response);
			});
	},
};

const mutations = {
	[GET_EVENT_SETTINGS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_EVENT_SETTINGS_SUCCESS]: (state, resp) =>
	{
		state.data = resp;
		state.status = FetchStatus.Loaded;
	},
	[GET_EVENT_SETTINGS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
